import React from "react";
import "./Mission.css";

const Mission = () => {
  return (
    <div className="AboutMission-container" >
      <div className="Mission-image-container">
        <img
          src={process.env.PUBLIC_URL + "/mission.jpg"}
          alt="Mission Image"
          className="hover:scale-105 transition-all delay-100 ease-in"
        />
      </div>
      <div className="Mission-message-container">
        <h2 className="Mission-message-heading">OUR MISSION</h2>
        <p className="Mission-message-paragraph">
        To empower students with knowledge, 
          skills and ethical values to excel in their 
          dynamic fields by providing transformative educational
           experience that foster intellectual growth, innovative and 
           critical thinking through research and diligent academic programs.
        </p>
      </div>
    </div>
  );
};

export default Mission;
